import React from 'react';
import { CheckCircle } from 'lucide-react';
import { Card, CardContent } from '../ui/card';

const BeforeAfter = () => {
  return (
    <section className="py-16 md:py-24 px-4 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">Avant / Après réparation</h2>
          <p className="text-lg text-gray-600">Découvrez la qualité de nos réparations</p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
          {/* Example 1: Écran iPhone cassé */}
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <CardContent className="p-0">
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_fix-phone-fast-1/artifacts/6a5dp813_images.jpg"
                  alt="Changement vitre écran iPhone cassé - Avant/Après réparation à Saint-Chamond"
                  className="w-full h-80 object-contain bg-blue-50"
                />
              </div>
              <div className="p-4 bg-gray-50">
                <h3 className="font-bold text-gray-900 mb-2">Écran iPhone cassé</h3>
                <p className="text-sm text-gray-600">Remplacement complet de l'écran avec affichage parfait restauré en 30 minutes</p>
              </div>
            </CardContent>
          </Card>

          {/* Example 2: Écran Samsung Galaxy fissuré */}
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <CardContent className="p-0">
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_fix-phone-fast-1/artifacts/5p6gkwcy_cache_2455591313.jpg"
                  alt="Réparation écran AMOLED Samsung Galaxy fissuré - Avant/Après à Saint-Chamond"
                  className="w-full h-80 object-contain bg-gray-50"
                />
              </div>
              <div className="p-4 bg-gray-50">
                <h3 className="font-bold text-gray-900 mb-2">Écran Samsung Galaxy fissuré</h3>
                <p className="text-sm text-gray-600">Remplacement écran AMOLED avec restauration complète des fonctionnalités</p>
              </div>
            </CardContent>
          </Card>

          {/* Example 3: Batterie iPhone */}
          <Card className="overflow-hidden hover:shadow-2xl transition-all duration-300 hover:-translate-y-2">
            <CardContent className="p-0">
              <div className="relative">
                <img
                  src="https://customer-assets.emergentagent.com/job_fix-phone-fast-1/artifacts/80f0rfok_Reparation-changement-batterie-iPhone-x.png"
                  alt="Changement batterie iPhone haute capacité - Avant/Après par Suro Phone Saint-Chamond"
                  className="w-full h-80 object-contain bg-white"
                />
              </div>
              <div className="p-4 bg-gray-50">
                <h3 className="font-bold text-gray-900 mb-2">Batterie iPhone remplacée</h3>
                <p className="text-sm text-gray-600">Batterie haute capacité : capacité maximale restaurée à 100% pour autonomie complète</p>
              </div>
            </CardContent>
          </Card>
        </div>

        <div className="mt-12 text-center">
          <Card className="max-w-2xl mx-auto bg-gradient-to-br from-blue-50 to-white border-2 border-blue-200">
            <CardContent className="p-8">
              <div className="flex items-center justify-center gap-3 mb-4">
                <CheckCircle className="w-8 h-8 text-green-500" />
                <h3 className="text-2xl font-bold text-gray-900">Garantie qualité</h3>
              </div>
              <p className="text-gray-700 mb-4">
                Toutes nos réparations sont réalisées avec des pièces premium et bénéficient d'une garantie de <strong>3 mois</strong>.
              </p>
              <ul className="grid md:grid-cols-3 gap-4 text-sm">
                <li className="flex items-center gap-2 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <span>Pièces testées</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <span>Réparation 30-60 min</span>
                </li>
                <li className="flex items-center gap-2 text-gray-700">
                  <CheckCircle className="w-5 h-5 text-blue-600 flex-shrink-0" />
                  <span>Garantie 3 mois</span>
                </li>
              </ul>
            </CardContent>
          </Card>
        </div>
      </div>
    </section>
  );
};

export default BeforeAfter;